
define('jst!presence/presence_bar/_new_comments_info',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<a href="#" class="new-comments-info-link">\n\n  <span class="text-bold"><%= count %></span>\n  <% if(count > 1) { %>\n    <%= t(\'new comments #presencebar\') %>\n  <% } else { %>\n    <%= t(\'new comment #presencebar\') %>\n  <% }  %>\n\n</a>');
 });

